import Vue from "vue";
// import "./assets/icons/material-design-icons.css";
import "./styles/main.sass";
import vuetify from "./plugins/vuetify";
import router from "./router";
import App from "./App.vue";
import BegentoUI, { numericOnly, charRestrict } from "@begentoOS/begento-ui";
import VueMask from "v-mask";
import "@begentoOS/begento-ui/dist/begento-ui.css";
// 1. Importamos normalmente (la URL la resolverá Webpack 5 Asset Modules)
import affUrl from './assets/dictionaries/en.aff';
import dicUrl from './assets/dictionaries/en.dic';
Vue.use(VueMask);
Vue.use(BegentoUI, { affUrl, dicUrl });
Vue.directive("numeric-only", numericOnly);
Vue.directive("char-restrict", charRestrict);
new Vue({
    router,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");
